var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderDk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172.09 179.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FE8100;}.cls-2{fill:#FE8100;}.cls-3{fill:#FE8100;}.cls-4{fill:#FE8100;}.cls-5{fill:#FE8100;}.cls-6{fill:#FE8100;}.cls-7{fill:#FE8100;}.cls-8{fill:#FE8100;}.cls-9{fill:#FE8100;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.59,
    cy: 43.4,
    r: 2.68
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.85,
    cy: 57.14,
    r: 3.94
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 6.02,
    cy: 71.91,
    r: 3.94
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.94,
    cy: 87.14,
    r: 3.94
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.55,
    cy: 103.11,
    r: 3.94
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.13,
    cy: 118.18,
    r: 3.94
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14.17,
    cy: 132.51,
    r: 3.94
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.15,
    cy: 145.63,
    r: 3.94
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.46,
    cy: 156.77,
    r: 3.94
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47.15,
    cy: 165.49,
    r: 3.94
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.31,
    cy: 171.96,
    r: 3.94
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.59,
    cy: 175.33,
    r: 3.94
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 92.65,
    cy: 175.85,
    r: 3.94
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.25,
    cy: 173.65,
    r: 3.91
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 123.27,
    cy: 168.43,
    r: 3.49
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.94,
    cy: 160.56,
    r: 3.18
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.17,
    cy: 150.56,
    r: 3.18
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 159.17,
    cy: 137.95,
    r: 2.52
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 166.85,
    cy: 123.9,
    r: 2.11
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 171.04,
    cy: 109.08,
    r: 1.05
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 171.08,
    cy: 97.17,
    r: 0.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.69,199.07,202,195.94l33-20.79s5.21-3.74,3.47-6.31-9.35,1.57-9.35,1.57l-43.82,27.05Z",
    transform: "translate(-165.1 -168)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M215.42,179.43s-16.14-3.56-19.2-4.08-6,2.73-6,2.73l14.12,9Z",
    transform: "translate(-165.1 -168)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.83,192.91l-5.13,3-5-3.62s-1-1.32.23-2.18,4,.07,4,.07Z",
    transform: "translate(-165.1 -168)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDk);
export default __webpack_public_path__ + "static/media/loaderDK.e65831339417c98f785aa2ccb687ffdc.svg";
export { ForwardRef as ReactComponent };